module.exports = __webpack_public_path__ + "img/error.7cce96d0.svg";